/* A question put to the room.

   The answer is held back one press, so a slide cannot give it away — which is
   also why no slide needs to tell the lecturer to ask. A slide showing only the
   question is the instruction. Outside the deck nothing is held back: what is
   on the projector must not be missing from the page or the handout.

   OWNED BY ITEM 3 OF docs/plan/00-prestavba-2026-08.md. */

import { Notes, Box, T } from "./shared";
import { revealed, useReveal } from "../routes/deck/reveal";
import type { AskBlock } from "../lib/types";

export function Ask({ b }: { b: AskBlock }) {
  const at = useReveal();
  const step = b.astep ?? 1;
  const held = b.answer || b.body || b.note?.length;
  return (
    <div className="ask">
      <div className="q"><T value={b.q} /></div>
      {b.lead ? <div className="lead"><T value={b.lead} /></div> : null}
      <Box text={b.out} cls="out" label={b.outLabel} />
      {held ? (
        <div className={"answer" + (revealed(step, at) ? " on" : "")} data-step={step}>
          {b.answer ? <div className="a"><T value={b.answer} /></div> : null}
          {b.body ? <div className="prose"><T value={b.body} block /></div> : null}
          <Notes b={b} />
        </div>
      ) : null}
    </div>
  );
}
